<template>
  <div id="vx-col w-full mb-base">
    <!-- PRODUCT TABLE -->
    <vs-popup :active.sync="showValidationPopup" title="Êtes-vous sûr de vouloir valider la supression du type de netlink ?">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <vs-button color="primary" class="mt-2 w-full" @click="accept()">Oui</vs-button>
        </div>
        <div class="vx-col sm:w-1/2">
          <vs-button color="primary" class="mt-2 w-full" @click="decline()">Non</vs-button>
        </div>
      </div>
    </vs-popup>
	<FilterCard :refreshKey="1" :filters="filtersTemplates" :showListLength="displayedNetlinkTypes.length" @filter="handleFilterEmits($event)" :actions="actionsTemplates" @action="handleActionEmits($event)" :onChangeEmit="true" />
    <!-- <NetlinkThemaTable/> -->
    <vx-card class="mt-1" v-if="netlink_types" style="max-height:69vh; overflow: auto;">
      <vs-table
        max-items="10"
        stripe
        :data="displayedNetlinkTypes"
      >
        <template slot="thead">
          <vs-th>Dénomination</vs-th>
          <vs-th>Récurrence</vs-th>
          <vs-th>NDD</vs-th>
          <vs-th>Description</vs-th>
          <!-- <vs-th>Type de prestation</vs-th> -->
          <vs-th v-if="$acl.check('admin')"></vs-th>
          <vs-th v-if="$acl.check('sadmin')"></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="index" v-for="(tr, index) in data">
			<div v-show="false">
				{{setRowNum(data.length)}}
			</div>

            <vs-td>{{ tr.name }}</vs-td>
            <vs-td>{{ tr.recurrency > 0 ? "Oui" : "Non" }}</vs-td>
            <vs-td>{{ tr.is_dns > 0 ? "Oui" : "Non" }}</vs-td>
            <vs-td class="w-1/2">{{ tr.description }}</vs-td>
            <!-- <vs-td>{{ getNetlinkName(tr.is_netlink) }}</vs-td> -->
            <vs-td v-if="$acl.check('admin')" style="text-align: center;">
              <vx-tooltip text="Modifier" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
                <vs-button
                    size="large"
                    color="primary"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-edit-2"
                    @click="$router.push({ name: 'update_entity', params: { netlinkTypeId: tr.id, updateEntityForm:'netlink_types' } })"
                ></vs-button>
              </vx-tooltip>
            </vs-td>
            <vs-td v-if="$acl.check('sadmin')" style="text-align: center;">
				<vx-tooltip text="Effacer" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
					<vs-button
						size="large"
						color="danger"
						type="flat"
						icon-pack="feather"
						icon="icon-trash-2"
						@click="displayValidationPopup(tr)"
					></vs-button>
				</vx-tooltip>
        	</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import FilterCard from "@/views/filters/FilterCard";
import NetlinkThemaTable from "@/components/tables/NetlinkThemaTable";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
import XLSX from "xlsx";
import VxCard from "../../components/widgets/vx-card/VxCard.vue";

export default {
	components: {FilterCard, VxCard, NetlinkThemaTable},
	name: "NetlinkTypesDashboard",
	mixins: [dbFieldConvertor, utilsMixin],
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null,
			netlinkThemaList: [],
			themRefreshKey: 0,
			selectedContract: null,
			showContractPopup: false,
			recurrencyFilter: "",
			recurrencyFilterOn: false,
			isDnsFilter: "",
			isDnsFilterOn: false,
			netlinkTypeFilter: "",
			netlinkTypeFilterOn: false,
			recurrencyOptions: [
				{text: "Non récurrent", value: 0},
				{text: "Récurrent", value: 1},
			],
			isDnsOptions: [
				{text: "Netlink Non-NDD", value: 0},
				{text: "Netlink NDD", value: 1},
			],
			displayedNetlinkTypes: [],
			displayedNetlinkTypesFull: [],
			showValidationPopup: false,
			netlinkTypeToDelete: null,
			actionsTemplates: [{
				order: 1,
				emitSlugName: "new_netlinkType",
				buttonName: "Nouveau Type de Netlink",
				buttonIcon: "icon-plus-circle",
				buttonColor: "primary",
			}, {
				order: 2,
				emitSlugName: "action_extract_netlinkTypes",
				buttonName: "Exporter",
				buttonIcon: "icon-download-cloud",
				buttonColor: "dark",
			}, ],
			filtersTemplates: [
				{
					order: 1,
					emitSlugName: "filter_name",
					filterPlaceHolder: "Type de Netlink",
					value: "",
					type: "Input",
				}, {
					order: 2,
					emitSlugName: "filter_recurrency",
					filterPlaceHolder: "Récurrence",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [
							{name: "Non récurrent", id: 1},
							{name: "Récurrent", id: 2},
						]
					}
				}, {
					order: 3,
					emitSlugName: "filter_isNDS",
					filterPlaceHolder: "Netlink NDD",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [
							{name: "Netlink Non-NDD", id: 1},
							{name: "Netlink NDD", id: 2},
						]
					}
				}]
		};
	},
	created() {
		this.getAllNetlinkTypes();
		this.getThema();
		if(this.netlink_types.length > 0){
			this.displayedNetlinkTypes = this.netlink_types;
			this.displayedNetlinkTypesFull = this.netlink_types;
		}
	},
	mounted() {
		this.displayedNetlinkTypes = this.netlink_types;
		this.displayedNetlinkTypesFull = this.netlink_types;
	},
	watch: {
		displayedNetlinkTypes: function(data){
			if(data.length == 0){
				this.setRowNum(0);
			}

		},

		netlink_types: function(){
			this.displayedNetlinkTypesFull = this.netlink_types;
			this.displayedNetlinkTypes = this.netlink_types;
		},
		recurrencyFilter: function() {
			if(this.recurrencyFilter == "") {
				this.recurrencyFilterOn = false;
			}
			else{
				this.recurrencyFilterOn = true;
			}
			////console.log("recurrencyFilter")
			this.displayedNetlinkTypes = this.filterNetlinkTypes(this.displayedNetlinkTypesFull);
		},
		isDnsFilter: function() {
			if(this.isDnsFilter == "") {
				this.isDnsFilterOn = false;
			}
			else{
				this.isDnsFilterOn = true;
			}
			////console.log("isDnsFilter")
			this.displayedNetlinkTypes = this.filterNetlinkTypes(this.displayedNetlinkTypesFull);
		},
		netlinkTypeFilter: function() {
			if(this.netlinkTypeFilter == "") {
				this.netlinkTypeFilterOn = false;
			}
			else{
				this.netlinkTypeFilterOn = true;
			}
			////console.log("deliveryFilter")
			this.displayedNetlinkTypes = this.filterNetlinkTypes(this.displayedNetlinkTypesFull);
		},
	},
	computed: {
		netlink_types: () => {
			return store.state.netlink_types;
		}
	},

	methods: {
		setRowNum(len){
			store.dispatch("setRowNum", len);
		},
		getAllNetlinkTypes() {
			this.$store.dispatch("getAllNetlinkTypes");
		},

		/**
		 * @method handleFilterEmits Receives filter emits and assign filters accordingly
		 * @param {Array} receivedEmit First cell is the filter's slug, second cell is the filter value
		 */
		handleFilterEmits(receivedEmit){
			//console.log(receivedEmit);
			// Find template value
			let templateRowIndex = this.filtersTemplates.findIndex(row => row.emitSlugName == receivedEmit[0]);
			if(templateRowIndex >= 0) this.filtersTemplates[templateRowIndex].value = receivedEmit[1].value;
			switch(receivedEmit[0]){
			case"filter_name":
				this.netlinkTypeFilter = receivedEmit[1].value;
				break;
			case"filter_recurreny":
				this.recurrencyFilter = receivedEmit[1].value - 1;
				break;
			case"filter_isDNS":
				this.isDnsFilter = receivedEmit[1].value - 1;
				break;
			}
			/*
			 * Find filter value
			 * switch(receivedEmit[0]){
			 * 	case "filter"
			 * }
			 */
		},

		/**
		 * @method handleActionEmits Receives action emits and assign actions accordingly
		 * @param {Array} receivedEmit First cell is the action's slug
		 */
		handleActionEmits(receivedEmit){
			//console.log(receivedEmit);
			// Find template value
			switch(receivedEmit[0]){
			case"action_extract_netlinkTypes":
				this.exportData(this.netlink_types);
				break;
			case"new_netlinkType":
				// <vs-button icon-pack="feather" icon="icon-plus-circle" color="primary" @click="$router.push({ name: 'new_entity' })">Nouveau contrat</vs-button>
				this.$router.push({name: "new_entity"});
				break;
			default:
				break;
			}
		},
		isFilterSet(){
			////console.log("isFilterSet BEGIN")
			if(this.netlinkTypeFilterOn || this.isDnsFilterOn || this.recurrencyFilterOn) return true;
			return false;
		},


		filterNetlinkTypes(netlink_types){
			////console.log("filterProviders BEGIN")
			let netlinkTypeList = [];
			let searchKeyList = {};


			if(this.recurrencyFilterOn){
				searchKeyList["recurrencyFilter"] = this.recurrencyFilter;
			}
			if(this.isDnsFilterOn){
				searchKeyList["isDnsFilter"] = this.isDnsFilter;
			}

			if(this.netlinkTypeFilterOn){
				searchKeyList["netlinkTypeFilter"] = this.netlinkTypeFilter.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
			}

			// //console.log("searchKeyList", searchKeyList)
			for(let netlinkTypeToFilter of netlink_types){

				let netlinkTypeSearchKeyList = {};
				this.recurrencyFilterOn ? netlinkTypeSearchKeyList["recurrencyFilter"] = netlinkTypeToFilter.recurrency : false;
				this.isDnsFilterOn ? netlinkTypeSearchKeyList["isDnsFilter"] = netlinkTypeToFilter.is_dns : false;
				this.netlinkTypeFilterOn ? netlinkTypeSearchKeyList["netlinkTypeFilter"] = netlinkTypeToFilter.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : false;

				let check = true;

				for(let key in searchKeyList) {
					/*
					 * //console.log("TYPE")
					 * //console.log(typeof netlinkTypeSearchKeyList[key])
					 */
					if(typeof searchKeyList[key] == "string"){
						if(typeof netlinkTypeSearchKeyList[key] == "string"){
							if(!netlinkTypeSearchKeyList[key].includes(searchKeyList[key])){
								check = false;
								break;
							}
						}
						else if(typeof netlinkTypeSearchKeyList[key] == "object"){
							////console.log("Array")
							let checkLoop = false;
							for(let value of netlinkTypeSearchKeyList[key]){
								let service_name = this.getServiceIdToName(value).toLowerCase();
								/*
								 * //console.log(service_name)
								 * //console.log(searchKeyList[key])
								 */
								if(service_name.includes(searchKeyList[key])){
									////console.log("checkLoop = true;")
									checkLoop = true;
								}
							}
							if(!checkLoop){
								check = checkLoop;
								break;
							}
						}
					}
					else{
						if(netlinkTypeSearchKeyList[key] != searchKeyList[key] - 1){
							check = false;
							break;
						}
					}
				}

				if(check) netlinkTypeList.push(netlinkTypeToFilter);
			}
			/*
			 * return result
			 * //console.log("filterProviders END")
			 */
			return netlinkTypeList;
		},

		deleteNetlinkType(netlinkTypeId){
			//console.log(netlinkTypeId);
			this.$http.delete(this.apiUrl + "netlink/type/delete/" + netlinkTypeId).then((err, result) => {
				if(err) //console.log(err);
				if(result) {
					//console.log(result);
					/*
					 * this.displayedNetlinkTypesFull = this.displayedNetlinkTypesFull.filter(function(element){
					 *   return element.id != product.id
					 * });
					 * this.displayedNetlinkTypes = this.displayedNetlinkTypesFull
					 */
				}
			});
		},

		displayValidationPopup(netlinkType){
			this.netlinkTypeToDelete = netlinkType;
			this.showValidationPopup = true;
		},

		accept(){
			this.deleteNetlinkType(this.netlinkTypeToDelete.id);
			this.showValidationPopup = false;
		},

		decline(){
			this.netlinkTypeToDelete = null;
			this.showValidationPopup = false;
		},
		exportData(dataIn){
			let data = JSON.parse(JSON.stringify(dataIn));

			for(let i = 0; i < data.length; i++){
				// this.$delete(data[i],"is_netlink");
				data[i]["recurrency"] = data[i]["recurrency"] > 0 ? "Oui" : "Non";
				data[i]["is_dns"] = data[i]["is_dns"] > 0 ? "Oui" : "Non";
			}
			// let today =
			let wb = XLSX.utils.book_new();
			let ws_name = "";

			let header = {
				header: [
					"id",
					"name",
					"recurrency",
					"is_dns",
					"description",
				],
				skipHeader: true,
				origin: -1
			};

			let header_names = [{
				id: "Identifiant",
				name: "Nom du Type de Netlink",
				recurrency: "Récurrence",
				is_dns: "Est Lien NDD ?",
				description: "Description",
			}];


			let ws = XLSX.utils.json_to_sheet(header_names, header);
			XLSX.utils.sheet_add_json(ws, data, header);

			/* Add the worksheet to the workbook */
			XLSX.utils.book_append_sheet(wb, ws, ws_name);

			XLSX.writeFile(wb, "Types-de-Netlink_export.xls");
		},
	}

};
</script>

<style scoped>
.fw-bold {
  font-weight: bold;
  color: black;
}

.center {
  justify-content: center;
}
</style>
